import * as log from "@/actions/logger";
import { getAmplitudeApiHeaders } from "@/services/Amplitude";
import { getClientApiUrl } from "@/utils";

export async function postContactForm(formData: Record<string, any>, domain: string) {
  const origin =
    process.env.NEXT_PUBLIC_ENV === "local" ? process.env.NEXT_PUBLIC_ORIGIN_URL : domain;
  const apiHost = getClientApiUrl();
  log.info({ component: "PostContactForm origin" }, origin);
  log.info({ component: "PostContactForm apiHost" }, apiHost);

  try {
    const response = await fetch(`${apiHost}/contact/send`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Origin: `${origin}`,
        ...getAmplitudeApiHeaders(),
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error("Network response was not ok.");
    }

    return response;
  } catch (error) {
    log.error(
      { err: error, module: "interface/api/PostContactForm" },
      "Error submitting contact form:"
    );
    throw error;
  }
}
